/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { getOntologyApiBaseUrl } from './ontology-api-env';

/** 本体应用列表 API（临时直连外部服务，后续切换 BFF） */
export const ONTOLOGY_APPS_API_URL = `${getOntologyApiBaseUrl()}/ontology-apps`;

/** 与 abr-webchat getOntologyApps 一致：仅拉取已发布本体 */
export const ONTOLOGY_APPS_STATUS_PUBLISHED = 'PUBLISHED';

/** 与 abr-webchat getOntologyApps 一致 */
export const ONTOLOGY_APPS_PAGE_SIZE = 1000;

/** 本体下模型列表 API 路径模板（`:appId` 替换为应用 ID） */
export const ONTOLOGY_APP_MODELS_API_URL_TEMPLATE = `${getOntologyApiBaseUrl()}/ontology-apps/:appId/models`;

/**
 * @deprecated 租户 ID 应从 UC 会话读取，仅保留供历史引用；新代码请使用 resolveOntologyTenantId。
 * 本地调试可通过 `VITE_ONTOLOGY_APPS_TENANT_ID` 注入（无默认值）。
 */
function getOntologyAppsTenantIdFromEnv(): string {
  if (typeof import.meta !== 'undefined') {
    const raw = import.meta.env.VITE_ONTOLOGY_APPS_TENANT_ID;
    if (raw && String(raw).trim()) {
      return String(raw).trim();
    }
  }
  return '';
}

/** @deprecated 见上方注释 */
export const ONTOLOGY_APPS_TENANT_ID = getOntologyAppsTenantIdFromEnv();
